import React, { Component } from "react";
import { connect } from "react-redux";
import { closeModal, openModal } from "../../../domain/ui/uiActions";
import { sendValidateAddAccount, setAuthorizedIdAdd, startValidateAddAccount } from "../../../domain/validation/validationActions";
import AccountAddValidationForm from "../../forms/secure/AccountAddValidationForm";
import StatusMessage from "../../presentational/StatusMessage";
import * as StatusMessages from "../../../constants/StatusMessages";
import { FormattedMessage } from "react-intl";
class AccountAddValidation extends Component {
    /* --- React Lifecycle Methods --- */
    /**
     * React lifecycle method
     *
     * @method render
     * @private
     * @returns {HTMLElement} Component element
     */
    render() {
        return (<div>
				<div className="vr vr_x5">
					<h1 className="hdg">
						<FormattedMessage id="accountAddValidation.header" defaultMessage="Add Account"/>
					</h1>
				</div>
				<StatusMessage isError isActive={this.props.validationError ? true : false} error={this.props.validationError ? this.props.validationError : null} customMessage={StatusMessages.AUTH.INTRO_CREATE_ACCOUNT} domain="validation"/>
				<div className="vr vr_x5">
					<div className="sides sides_x4S">
						<AccountAddValidationForm authIndividuals={this.props.authorizedIndividuals ? this.props.authorizedIndividuals : []} closeModal={this.props.closeModal} customFields={this.props.validationRequirements ? this.props.validationRequirements : []} fieldErrors={this.props.validationFieldErrors} firstName={this.props.firstName} lastName={this.props.lastName} openModal={this.props.openModal} sendValidation={this.props.sendValidateAddAccount} setAuthId={this.props.setAuthorizedIdAdd} startValidation={this.props.startValidateAddAccount} validation={this.props.validationRequest} isLoading={this.props.validationIsLoading} locale={this.props.locale} deceased={this.props.deceased}/>
					</div>
				</div>
			</div>);
    }
}
/* --- React Redux bootstrapping --- */
const mapStateToProps = (state) => ({
    authorizedIndividuals: state.validation.authorized,
    firstName: state.profile.profile.firstName,
    lastName: state.profile.profile.lastName,
    validationError: state.validation.error,
    validationFieldErrors: state.validation.fieldErrors,
    validationIsLoading: state.validation.isLoading,
    validationRequest: state.validation.validationRequest,
    validationRequirements: state.validation.confirmation,
    deceased: state.validation.deceased,
    locale: state.i18n.locale
});
const bindActionsToProps = {
    closeModal,
    openModal,
    sendValidateAddAccount,
    setAuthorizedIdAdd,
    startValidateAddAccount
};
/* Create and export container component that wraps AccountAddValidation for property binding */
export default connect(mapStateToProps, bindActionsToProps)(AccountAddValidation);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/modals/AccountAddValidation.tsx